/**
 Parent component of all panels in Overview tab
 */
import React from 'react';
import { Panel } from 'react-bootstrap';
import '../css/generic-panel.css';

export default class GenericPanel extends React.Component {
    render() {
        return (
            <Panel className="generic-panel">
                <Panel.Heading className='generic-panel-heading'>
                    <Panel.Title>
                        <div className="hr">
                            <span>{this.props.title ? this.props.title : ''}</span>
                        </div>
                    </Panel.Title>
                    {this.props.headingWidgets ? this.props.headingWidgets : ''}
                </Panel.Heading>
                <Panel.Body className='generic-panel-body'>
                    {this.props.children}
                </Panel.Body>
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/generic_panel.js